import React from 'react';
import { Button } from './ui';
import { ShieldCheck, Zap } from 'lucide-react';
const trackAddToCart = () => {
  try {
    const fbq = (window as any).fbq;
    if (fbq) fbq('track', 'AddToCart', {
      currency: 'USD',
      value: 17,
      content_name: 'Plan de 21 Días de Vitalidad Menopáusica',
      content_type: 'product'
    });
  } catch (e) {}
};
export const PriceCTA = ({
  className = ''
}: {
  className?: string;
}) => {
  return <div className={`max-w-md mx-auto bg-white rounded-3xl shadow-lg border border-cream-dark p-8 text-center ${className}`} data-id="element-246">
      <span className="text-sm text-brown-light uppercase tracking-wider font-bold" data-id="element-247">
        Plan + 3 Bonos · Inversión única
      </span>
      <div className="flex items-baseline justify-center gap-3 mt-1" data-id="element-248">
        <span className="text-2xl text-brown-light/50 line-through font-medium" data-id="element-249">
          $47
        </span>
        <span className="text-5xl font-bold text-coral" data-id="element-250">$17</span>
        <span className="text-2xl text-brown-light font-normal" data-id="element-251">USD</span>
      </div>
      <span className="inline-flex items-center gap-1 mt-2 bg-sage-light text-sage text-sm font-bold px-3 py-1 rounded-full" data-id="element-252">
        <Zap className="w-3.5 h-3.5" data-id="element-253" />
        Ahorra más del 60%
      </span>

      <div className="mt-5 mb-5 flex items-start gap-3 bg-sage-light/40 border border-sage/20 rounded-2xl p-4 text-left" data-id="element-254">
        <ShieldCheck className="w-6 h-6 text-sage shrink-0 mt-0.5" data-id="element-255" />
        <p className="text-sm text-brown-light leading-relaxed" data-id="element-256">
          <span className="font-bold text-brown" data-id="element-257">
            Garantía de 7 días sin riesgo
          </span>
        </p>
      </div>

      <Button fullWidth href="https://pay.hotmart.com/W105376697A" onClick={trackAddToCart} data-id="element-258">
        ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
      </Button>

      <p className="mt-4 text-sm font-bold text-brown" data-id="element-259">
        Acceso instantáneo · Pago 100% seguro
      </p>
    </div>;
};